export const CREATE_ONLINE_ROOM = 'CREATE_ONLINE_ROOM'
export const UPDATE_ONLINE_ROOM = 'UPDATE_ONLINE_ROOM'
export const DELETE_ONLINE_ROOM = 'DELETE_ONLINE_ROOM'
export const SET_IS_LOADING_FALSE = 'SET_IS_LOADING_FALSE'
export const SET_IS_LOADING_TRUE = 'SET_IS_LOADING_TRUE'
export const RESET_CREATED_ROOM = 'RESET_CREATED_ROOM'

export const GET_CONNECTION_LINK_TO_BBB_ROOM = 'GET_CONNECTION_LINK_TO_BBB_ROOM'
export const RESET_GET_CONNECTION_LINK_TO_BBB_ROOM = 'RESET_GET_CONNECTION_LINK_TO_BBB_ROOM'
